import React, { useState, useRef, useEffect } from "react";
import "./Chat.css";
import LatexRenderer from "./LatexRenderer";
import { parseMathText } from "../utils/parseMathText";
import { normalizeChatMath } from "../utils/chatMath";

const Chat = ({
  conversation,
  onSendMessage,
  disabled = false,
  placeholder = "Ask for guidance...",
  disabledPlaceholder = "Guidance is disabled right now.",
  disabledReason = "",
  busy = false,
}) => {
  const [message, setMessage] = useState("");
  const endOfMessagesRef = useRef(null);

  const handleSend = (e) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message);
      setMessage("");
    }
  };

  useEffect(() => {
    const node = endOfMessagesRef.current;
    if (node && typeof node.scrollIntoView === "function") {
      node.scrollIntoView({ behavior: "smooth" });
    }
  }, [conversation]);

  const renderMessageContent = (content, keyPrefix) => {
    const normalized = normalizeChatMath(content);
    const parts = parseMathText(normalized);
    if (!parts.length) return content;
    return parts.map((part, index) => {
      if (part.type === "latex") {
        const className = part.displayMode
          ? "chat-latex chat-latex--block"
          : "chat-latex chat-latex--inline";
        const Wrapper = part.displayMode ? "div" : "span";
        return (
          <Wrapper key={`${keyPrefix}-latex-${index}`} className={className}>
            <LatexRenderer
              latex={part.value}
              displayMode={part.displayMode}
            />
          </Wrapper>
        );
      }
      return (
        <span key={`${keyPrefix}-text-${index}`}>{part.value}</span>
      );
    });
  };

  return (
    <div className="chat-panel">
      <div className="chat-history">
        {conversation.map((entry, index) => (
          <div key={index} className={`chat-message chat-message--${entry.role}`}>
            <div className="chat-message__bubble">
              {renderMessageContent(entry.content, `msg-${index}`)}
            </div>
          </div>
        ))}
        <div ref={endOfMessagesRef} />
      </div>
      <form className="chat-form" onSubmit={handleSend}>
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder={disabled ? disabledPlaceholder : placeholder}
          disabled={disabled || busy}
        />
        <button
          type="submit"
          className="btn btn--primary"
          disabled={disabled || busy || !message.trim()}
        >
          Send
        </button>
      </form>
      {disabledReason ? (
        <p className="mini-label" style={{ margin: 0 }}>
          {disabledReason}
        </p>
      ) : null}
    </div>
  );
};

export default Chat;
